<template>
  <div class="error-state text-content">
    <icon
      :name="iconName"
      class="error-state__icon"
    />
    <div class="error-state__content">
      <h1 v-html="title" />
      <p v-html="text" />
    </div>
    <slot
      v-if="$slots.buttons"
      name="buttons"
    />
    <app-button
      v-else
      @click="$emit('click')"
    >
      {{ buttonText }}
    </app-button>
  </div>
</template>

<script setup>
  defineProps({
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    iconName: {
      type: String,
      default: 'line-md:alert-circle',
    },
  })

  defineEmits(['click'])
</script>

<style lang="scss">
  .error-state {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .error-state__icon {
    font-size: 3rem;
    color: var(--color-secondary);
  }

  .error-state__content {
    text-align: center;
    margin: var(--spacing-medium) 0;
  }
</style>
